define('home/views/SettingsDeleteView',[
    'jquery',
    'underscore',

    'core/api',
    'core/strings',

    'home/templates/settingsDelete',
    'home/views/common/BaseSettingsView',
], function (
    $,
    _,

    api,
    strings,

    settingsDeleteTemplate,
    BaseSettingsView
) {
    'use strict';

    var gettext = strings.get;

    var SettingsDeleteView = BaseSettingsView.extend({
        template: settingsDeleteTemplate,

        events: {
            'submit form': 'handleDeleteAccount',
            'change input[type=radio]': 'handleReasonChange',
        },

        initialize: function (options) {
            this.session = options.session;

            // We manually scroll to the top of the tab as when users click on 'delete account' button
            // at the bottom of the accounts tab, they will be sent to this tab but will only see the
            // bottom of the tab contents if they aren't scrolled to the top.
            //
            // TODO - This needs a rethink of the way we show the contents of tab, since we shouldn't be
            // forcing a scroll to the top.
            $(window).scrollTop(0);
        },

        handleReasonChange: function (ev) {
            ev.preventDefault();

            var $radio = $(ev.currentTarget);
            this.$('[data-role=delete-resolution]').addClass('hidden');
            $radio.parent().next('[data-role=delete-resolution]').removeClass('hidden');
        },

        handleDeleteAccount: function (ev) {
            ev.preventDefault();

            var confirmationMsg = gettext('This will delete your account permanently. Are you sure?');
            if (!window.confirm(confirmationMsg))  // eslint-disable-line no-alert
                return;

            this.updateStatus('is-saving');

            var data = _.reduce($(ev.originalEvent.target).serializeArray(), function (result, item) {
                result[item.name] = item.value;
                return result;
            }, {});
            this.deleteAccount(data)
                .done(_.bind(this.session.logout, this.session))
                .fail(_.bind(this.showError, this));
        },

        showError: function (error) {
            var response = error.responseJSON;
            var $errorElement = this.$('[data-role=error-alert]');

            if (response.code === 2) {
                if (response.response === 'Invalid password.')
                    $errorElement.text(gettext('Invalid password.'));
                else
                    $errorElement.text(gettext('Please select a reason.'));
            } else {
                $errorElement.text(response.response);
            }

            this.updateStatus('');
        },

        deleteAccount: function (data) {
            return api.call('internal/users/delete', {
                method: 'POST',
                data: data,
            });
        },

    });

    return SettingsDeleteView;
});

